import { Component, ComponentFactory } from "@angular/core";

export interface LazyLoaderModuleRef {
	getComponent: () => ComponentFactory<LazyComponent>;
}

export interface LazyItem {
	name: string;
	path: () => Promise<{ [key: string]: any }>;
	type?: LazyItemType;
	moduleData?: LazyItemExtraConfig;
}

export interface LazyComponent extends Component {
	data: {
		moduleData: LazyItemExtraConfig;
	};
}

export interface LazyItemExtraConfig {
	[key: string]: string | boolean | number;
}

export enum LazyItemType {
	component = "component",
	module = "module",
}
